import { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import { ErrorPage } from "components/ErrorPage";

const Custom404Page = () => (
  <ErrorPage title="error404.title" description="error404.description" />
);

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? "es-AR", ["common"])),
    },
  };
};

export default Custom404Page;
